import { Link } from "react-router-dom";
import logoWhite from "../../assets/oq-logo-1-white.svg";
import linkedInIcon from "../../assets/homepage/social-icon-linkedin.svg";
import "./Footer.scss";

export default function Footer() {
  return (
    <footer>
      <div className="footer-cols-wrapper">
        <div className="col-1">
          <div className="col-inner-wrapper">
            <Link to="/">
              <img src={logoWhite} alt="OphthalmologyQ" className="logo-footer" />
            </Link>
            <p>
              <strong>FRCOphth Part 1 &amp; Part 2</strong> question banks covering <strong>every module and every
              area</strong>—exam-style questions, timed mock exams, and UK-aligned explanations. Plus <strong>MSRA</strong>,{" "}
              <strong>Duke Elder</strong>, interview resources, and <strong>coaching from leading UK ophthalmologists</strong>.{" "}
              <strong>Co-built by ophthalmologists, for ophthalmologists.</strong>
            </p>
            <div className="social-icons-wrapper">
              <Link to={"https://linkedin.com"} target="blank">
                <img src={linkedInIcon} alt="Link to MasterQ LinkedIn page" />
              </Link>
            </div>
          </div>
        </div>

        <div className="col-2">
          <div className="col-inner-wrapper">
            <h4>Resources</h4>
            <ul>
              <li>
                {/* IMPORTANT: Link used to ensure site doesn't reload, especially becaue we need to include window.location.origin,
                so the navigation works from any public page across the whole site */}
                <Link to={window.location.origin + '/#about-oq'}>For Students</Link>
              </li>
              <li>
                <Link to={window.location.origin + '/#why-us'}>For Schools</Link>
              </li>
              <li>
                <Link to={window.location.origin + '/#our-vision'}>Our Vision</Link>
              </li>
              <li>
                <Link to={window.location.origin + '/#pricing'}>Pricing</Link>
              </li>
              <li>
                <Link to={window.location.origin + '/#newsletter'}>Newsletter</Link>
              </li>
              <li>
                <Link to={"/sign-up"}>Sign Up</Link>
              </li>
              <li>
                <a href="mailto:ali.hejazi@masterq.co.uk">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-3">
          <div className="col-inner-wrapper">
            <h4>Contact Us</h4>
            <ul>
              <li>ali.hejazi@masterq.co.uk</li>
              <li>
                MasterQ Ltd,<br/>The Exchange,<br/>3 Centenary Square,<br/>Birmingham,<br/>B1 2DR,<br/>United Kingdom.
              </li>

              <li>
              <a onClick={() => {
                  window.scrollTo(0, 0)
                }} id="backToTop">Scroll to top ^</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom-part">
        <p>Copyright © {new Date().getFullYear()} OphthalmologyQ. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
